<script>
// MyComponent.vue
// import ordersCSV from '../orders.csv'
// import productsCSV from '../products.csv'
import Papa from 'papaparse'
import VueJsonToCsv from 'vue-json-to-csv'
import { onMounted, onUnmounted, ref } from 'vue'

export default {
  name: 'TextField',
  props: {
    value: String,
  },
  components: {
    VueJsonToCsv,
  },
  data() {
    return {
      localValue: '',
      show: false,
      records: [
        {
          //This is the header
          OrderNumber: 'Order Number',
          Name: 'Name',
          Barcode: 'Barcode',
          ProductReturned: 'Product',
          SKU: 'No',
          Notes: 'No',
        },
      ],

      nameList: ['Name'],
      orderList: ['Order Number'],
      barcodeList: ['Barcodes'],
      productList: ['Product'],
      currentPos: 1,
      productsCSV:[],
      ordersCSV:[]

    }
  },
  methods: {
    handleEnter() {
      // Store or use localValue here
      if (this.localValue) {
        if (this.localValue[0] == '#') {
          var order = this.ordersCSV.filter((el) => el.Name === this.localValue)[0]
          this.orderPush()
          console.log(order)
        } else if (this.localValue.length == 5) {
          this.localValue = '#' + this.localValue
          this.orderPush()
        } else {
          //should be a barcode number
          if (Number.isFinite(Number(this.localValue))) {
            //if its a number barcode
            //check if it starts with a 0
            while (this.localValue.charAt(0) === '0') {
              this.localValue = this.localValue.substring(1)
            }
            var product = this.productsCSV.filter(
              (el) => el['Variant Barcode'] === this.localValue.toString(),
            )[0]
            console.log(product)

            if (typeof product !== 'undefined') {
              //localValue is the barcode
              // console.log(typeof product)
              //check if the size is in the wrong place
              var size = ''
              if (product['Option1 Value'].length > 2) {
                size = product['Option2 Value']
              } else {
                size = product['Option1 Value']
              }

              var productName = String(product['Title'] + ' ' + size)
              console.log(productName)
              this.barcodeList.push(this.localValue)
              this.productList.push(productName)

              //if name and order are entered, but barcode is not entered yet
              if (this.records[this.currentPos].Barcode == '') {
                this.records[this.currentPos].Barcode = this.localValue
                this.records[this.currentPos].ProductReturned = productName
                console.log(this.localValue)
              } else {
                //Enter in new row
                this.currentPos += 1
                this.records[this.currentPos] = {
                  OrderNumber: '',
                  Name: '',
                  Barcode: this.localValue,
                  ProductReturned: productName,
                  SKU: '',
                  Notes: '',
                }
                this.nameList.push('-')
                this.orderList.push('-')
              }
              //push into csv
            } else {
              //if the barcode is not found
              console.log('Not a valid barcode. Please enter product item')

              if (this.records[this.currentPos].Barcode == '') {
                this.barcodeList.push(this.localValue)
                this.records[this.currentPos].Barcode = this.localValue
              } else {
                this.barcodeList.push(this.localValue)

                this.nameList.push('-')
                this.orderList.push('-')
                this.currentPos += 1
                this.records[this.currentPos] = {
                  OrderNumber: '',
                  Name: '',
                  Barcode: this.localValue,
                  ProductReturned: '',
                  SKU: '',
                  Notes: '',
                }
              }
            }
          } else {
            //if its not a number (meaning it just asked you to enter product item)
            console.log('this is string')
            this.productList.push(this.localValue)
            this.records[this.currentPos].ProductReturned = this.localValue
            this.localValue = ''
          }
        }
      } else {
        console.log('its nothing')
      }
      this.localValue = ''
    },
    showObj() {
      console.log(this.records)
      console.log(this.convertToCsv())
    },
    convertToCsv() {
      const array = [Object.keys(this.records[0])].concat(this.records)

      return array
        .map((it) => {
          return Object.values(it).toString()
        })
        .join('\n')
    },
    downloadCsv() {
      const blob = new Blob([this.convertToCsv()], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.setAttribute('href', url)
      link.setAttribute('download', 'returns.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    orderPush() {
      var order = this.ordersCSV.filter((el) => el.Name === this.localValue)[0]
      this.currentPos += 1
      if (typeof order !== 'undefined') {
        //First checks if its been over 30 days
        var fulfilledAt = order['Fulfilled at'].split(' ')[0]
        var fulDate = new Date(fulfilledAt)
        // console.log(fulDate)
        var curDate = new Date()
        var diffDays = (diffDays = Math.floor((curDate - fulDate) / (1000 * 60 * 60 * 24)))
        console.log(diffDays + ' days since fulfillment')
        var over30 = ''
        if (diffDays > 30) {
          over30 = diffDays + ' days since fulfillment'
        }
        var customerName = order['Billing Name']
        console.log(customerName)
        this.barcodeList.push('')
        this.productList.push('')
        this.orderList.push(this.localValue)
        this.nameList.push(customerName)
        //push into new thing
        this.records[this.currentPos] = {
          OrderNumber: this.localValue,
          Name: customerName,
          Barcode: '',
          ProductReturned: '',
          SKU: '',
          Notes: over30,
        }
        //push into csv
      } else {
        console.log('Invalid Order Number')
      }
    },
    handleFileUploadProd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.productsCSV = results.data;
            console.log("Parsing complete:", this.productsCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    },
    handleFileUploadOrd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true, // Treat the first row as headers
          skipEmptyLines: true, // Skip any empty lines in the file
          complete: (results) => {
            // The parsed data is available in results.data as an array of objects
            this.ordersCSV = results.data;
            console.log("Parsing complete:", this.ordersCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    }
  },
  created() {
    this.localValue = this.value
    this.$watch('localValue', (value) => {
      this.$emit('input', value)
    })

    window.addEventListener('beforeunload', function (event) {
      event.returnValue = 'Are you sure you wanna unload'
    })
  },
}
</script>

<template>
  <div class="main">
    <h1>Process Returns</h1>
    <p>
      Scan order number then the barcode. The product should automatically populate after scanning
      each barcode, if not, then manually type it after scanning the barcode. If scanning an order
      number doesnt work, then that means we need to update the order list. [Press f12 to see any
      errors]
    </p>
    Product
    <input v-if="!productsCSV.length" id="choose-file" type="file" @change="handleFileUploadProd" accept=".csv" placeholder="Enter Product CSV" /> <br>
    Orders
    <input v-if="!ordersCSV.length" id="choose-file" type="file" @change="handleFileUploadOrd" accept=".csv" placeholder="Enter Order CSV" /> <br>
    <input
      v-model="localValue"
      @keyup.enter="handleEnter"
      placeholder="Enter Order Number/Barcode/Product"
    />
    <div class="list-container">
      <ul class="col">
        <li class="order-list" v-for="(order, index) in orderList" :key="index">
          {{ order }}
        </li>
      </ul>
      <ul class="col">
        <li class="name-list" v-for="(name, index) in nameList" :key="index">
          {{ name }}
        </li>
      </ul>
      <ul class="col">
        <li class="barcode-list" v-for="(barcode, index) in barcodeList" :key="index">
          {{ barcode }}
        </li>
      </ul>
      <ul class="col">
        <li class="product-list" v-for="(product, index) in productList" :key="index">
          {{ product }}
        </li>
      </ul>
    </div>
    <button @click="this.show = !this.show">Show Object</button>
    <button @click="downloadCsv">Download CSV</button>
    <!-- Maybe copy to clipboard instead? -->
  </div>
  <p v-if="show">{{ convertToCsv() }}</p>
</template>

<style scoped>
.main {
  margin: auto;
  text-align: center;
  align-self: center;
}
.col {
  list-style-type: none;
}
.list-container {
  display: flex;
  justify-content: space-around;
  border: 2px solid white;
}
button {
  background-color: blueviolet;
  color: white;
  padding: 1em;
  border-radius: 1em;
  border: 2px solid white;
  margin: 1em;
}
button:hover {
  background-color: #892be29a;
  cursor: pointer;
}

input {
  padding: 0.5em;
  border: 4px solid black;
  margin-bottom: 1em;
}
p {
  margin: auto;
  width: 60%;
}

</style>
